@if (isPhoneDamaged()) {
  @for (summary of summaryRows(); track summary.damageReason) {
    <div class="summary-row">
      <span>{{ summary.damageReason }}</span>
      <span class="summary-value">{{ summary.hasDamage ? 'Ja' : 'Nei' }}</span>
    </div>
  }

  @if (hasInsurance) {
    <app-ice-alert type="info" [iconName]="IconNames.ice_info">
      <b>Mobilen har skader som må repareres.</b>
      <p class="summary-info-text">
        Dette dekkes vanligvis av forsikringen, men den dekker ikke interne eller selvpåførte skader.
      </p>
    </app-ice-alert>
  } @else {
    <app-ice-alert type="error" [iconName]="IconNames.ice_warning">
      <b>Mobilen har skader som må repareres</b>
      <br />
      <p class="summary-info-text">
        Denne avtalen har ikke forsikring, så telefonen må repareres hos en godkjent reparatør før innbytte.
      </p>
    </app-ice-alert>
  }
} @else {
  <div class="summary-row">
    <span>Har telefonen noen skader eller problemer?</span>
    <span class="summary-value">Nei</span>
  </div>

  @if (!hasInsurance) {
    <p class="assessment-title">Vurdering av mobil</p>
    <p>
      Selv om kunden har oppgitt at mobilen er uten skader, gjør vi en vurdering for å sikre at alt stemmer. Hvis vi finner
      noe, kan kunden bli fakturert for differansen mellom innbytteverdi og mobilens faktiske tilstand. Vi kontakter kunden
      dersom vi finner noen skader.
    </p>
  }

  <app-ice-alert type="success" [iconName]="IconNames.ice_checkmark">
    Alt i orden! Reparasjon er ikke nødvendig
  </app-ice-alert>

  @if (!hasInsurance) {
    <app-ice-checkbox
      forId="is-customer-informed"
      label="Kunden er informert om dette"
      ngDefaultControl
      testId="is-customer-informed-input"
      [errorOnTouchedOnly]="true"
      [formControl]="isCustomerInformed"
    />
  }
}
